









































































































































































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import uuifComponent from '@/shared/uuifComponent';
const cssPrefix = 'printQuote';
@Component({
  components: {
    ...uuifComponent,
  },
})
export default class SandboxPrintQuoteDetail extends SwExtendedVue {
  cssPrefix = cssPrefix;

  quoteDetail: any[] = [];

  assochint: string = '';
  selectedProduct: any = {};
  serialNumber: string = '';
  expiredServices: any = {};
  loadingCompleted: boolean = false;
  // visible:boolean;

  get quoteID() {
    return this.$route.query.selectedQuoteId;
  }
  mounted() {
    if (this.quoteID) {
      const payload = {
        quoteID: this.quoteID,
        isquotereceipt: 'YES',
      };
      this.$store.dispatch('SnbQuotesStoreModule/getQuoteForDetails', payload)
      .then((res) => {
        this.$store.commit('stopLoading');
        if (res.operationStatus === 'OK') {
          this.quoteDetail = res.content;
        }
        console.warn(res);
      });
    }
  }

  printPage() {
    const printer = document.getElementById('printer');
    if (printer) {
      printer.style.visibility = 'hidden';
      const page = document.getElementById('printQuoteDetail');
      if (page) {
        page.style.height = 'unset';
        window.print();
        printer.style.visibility = 'visible';
        page.style.height = '95vh';
      }
    }
  }
}
